import { BrowserRouter as Router, Redirect, Switch } from 'react-router-dom';
import Catalogue from './routes/Catalogue';
import Auth from './routes/Auth';
import Pills from './routes/Pills';
import Brands from './routes/Brands';
import Orders from './routes/Orders';
import Services from './routes/Services';
import anonymousUser from './utils/anonymousUser';
import { PrivateRoute, PublicRoute } from './routes/navigation';
import { UserAuthContextProvider } from './state/userAuthContext';
import { Suspense, useEffect } from 'react';
import Bussines from './routes/Bussines';
import Blog from './routes/Blog';
import Countries from './routes/Countries';
import Configuration from './routes/Configuration';
import Unauthorized from './routes/Unauthorized';
import OpsSupport from './routes/OpsSupport';
import Account from './routes/Account';
import { Wrapper } from '@googlemaps/react-wrapper';
import { ReactNotifications } from 'react-notifications-component';
import { responsiveConfig } from './utils/activeNotify';
import Dashboard from './routes/Dashboard';
import Tools from './routes/Tools';
import BulkUpload from './routes/BulkUpload';
import StockOrders from './routes/StockOrders';
import TrackingOrder from 'routes/TrackingOrder';
import Announcements from './routes/Announcements';
import Billing from './routes/Billing';
import Quote from 'routes/Quote';
import './App.css';

function App() {
  useEffect(() => {
    anonymousUser();
  }, []);
  return (
    <>
      <Suspense fallback="LOADING">
        <UserAuthContextProvider>
          <>
            <ReactNotifications {...responsiveConfig} />
            <Router>
              <Wrapper apiKey={process.env.REACT_APP_GOOGLE_MAPS_KEY as string} libraries={['places']}>
                <Switch>
                  <PrivateRoute path="/dashboard" component={Dashboard} />
                  <PrivateRoute path="/catalog" component={Catalogue} />
                  <PrivateRoute path="/category" component={Pills} />
                  <PrivateRoute path="/brand" component={Brands} />
                  <PrivateRoute path="/organization" component={Bussines} />
                  <PrivateRoute path="/tools" component={Tools} />
                  <PrivateRoute path="/order" component={Orders} />
                  <PrivateRoute path="/blog" component={Blog} />
                  <PrivateRoute path="/logistic-service" component={Services} />
                  <PrivateRoute path="/billing" component={Billing} />
                  <PrivateRoute path="/bulk-upload" component={BulkUpload} />
                  <PrivateRoute path="/country" component={Countries} />
                  <PrivateRoute path="/configuration" component={Configuration} />
                  <PrivateRoute path="/unauthorized" component={Unauthorized} />
                  <PrivateRoute path="/ops-support" component={OpsSupport} />
                  <PrivateRoute path="/account" component={Account} />
                  <PrivateRoute path="/stock" component={StockOrders} />
                  <PrivateRoute path="/tracking-order" component={TrackingOrder} />
                  <PrivateRoute path="/announcement" component={Announcements} />
                  <PrivateRoute path="/quote" component={Quote} />
                  <PublicRoute path="/auth" component={Auth} />
                  <Redirect from="*" to="/auth/login" />
                </Switch>
              </Wrapper>
            </Router>
          </>
        </UserAuthContextProvider>
      </Suspense>
    </>
  );
}

export default App;
